import { h, Component } from 'preact';

import HeaderExpanded from './HeaderExpanded';
import HeaderCollapsed from './HeaderCollapsed';
import './index.less';

import { getScrollTop } from '../../lib/PositionCache';
import { getCatalogueTheme } from '../../lib/Theme';
import { setNativeStatusBarColor } from '../../../../../nativeConnectors/platform';
import { getCompanyDomains as getSingleCompanyDomains } from '../../lib/Amalgam';
import { getCompanyDomains as getGroupCompanyDomains } from '../../lib/GroupAmalgam';
import { getCurrentRouteName, isGroupRoute } from '../../lib/Route';

class Header extends Component {
  constructor (props) {
    super(props);
    this.state = {
      headerCollapsed: false,
      scrollTop: getScrollTop()
    };

    const companyDomains = isGroupRoute(getCurrentRouteName())
      ? getGroupCompanyDomains() || {}
      : getSingleCompanyDomains() || {};
    const { host } = window.location;

    let hostFoundInCompanyDomains = false;
    const customCompanyDomains = companyDomains.custom || [];
    const catalogCompanyDomains = companyDomains.catalog || [];
    if (customCompanyDomains.indexOf(host) !== -1) {
      hostFoundInCompanyDomains = true;
    } else if (catalogCompanyDomains.indexOf(host) !== -1) {
      hostFoundInCompanyDomains = true;
    }

    let homepage = null;
    if (hostFoundInCompanyDomains) {
      homepage = host;
    } else if (customCompanyDomains.length) {
      homepage = customCompanyDomains[0];
    } else if (catalogCompanyDomains.length) {
      homepage = catalogCompanyDomains[0];
    }

    this.homepage = homepage;
  }

  componentDidMount () {
    window.addEventListener('scroll', this.onScroll);
    this.onHeaderCollapseChange();
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.onScroll);
  }

  componentDidUpdate (_, prevState) {
    const { headerCollapsed } = this.state;
    const { headerCollapsed: prevHeaderCollapsed } = prevState;
    if (prevHeaderCollapsed !== headerCollapsed) {
      this.onHeaderCollapseChange();
    }
  }

  onHeaderCollapseChange = () => {
    const { showExpandedHeader } = this.props;
    const { headerCollapsed } = this.state;
    const { homeGrid, homepage } = getCatalogueTheme() || {};
    const { backgroundColor } = homeGrid || {};
    const { collapsedHeaderBackground } = homepage || {};
    if (headerCollapsed || !showExpandedHeader) {
      setNativeStatusBarColor(collapsedHeaderBackground);
      return;
    }
    setNativeStatusBarColor(backgroundColor);
  };

  onScroll = () => {
    const scrollTop = getScrollTop();

    const expandedHeaderRect = this.expandedHeader
      ? this.expandedHeader.getBoundingClientRect()
      : null;

    if (expandedHeaderRect && scrollTop >= expandedHeaderRect.height) {
      this.setState({ headerCollapsed: true });
    } else if (expandedHeaderRect && scrollTop < expandedHeaderRect.height) {
      this.setState({ headerCollapsed: false });
    }

    this.setState({ scrollTop });
  };

  render () {
    const { headerCollapsed, scrollTop } = this.state;
    const {
      onSearch,
      showBanner,
      showExpandedHeader,
      showBackButtonInExpandedHeader,
      showSearch,
      showHeaderCollapsedBorder,
      showHeaderCollapsedShadow,
      goBack,
      containerStyle,
      showBackForSingleCatalogue
    } = this.props;
    const homepageLink = this.homepage ? `https://${this.homepage}` : undefined;

    return (
      <header className="header">
        {showExpandedHeader && (
          <HeaderExpanded
            showBackButtonInExpandedHeader={showBackButtonInExpandedHeader}
            showBanner={showBanner}
            showSearch={showSearch}
            onRender={(element) => (this.expandedHeader = element)}
            homepageLink={homepageLink}
            goBack={goBack}
            containerStyle={containerStyle}
            showBackForSingleCatalogue={showBackForSingleCatalogue}
          />
        )}
        {headerCollapsed || !showExpandedHeader ? (
          <HeaderCollapsed
            onSearch={onSearch}
            showSearch={showSearch}
            showExpandedHeader={showExpandedHeader}
            homepageLink={homepageLink}
            showHeaderCollapsedBorder={showHeaderCollapsedBorder}
            showHeaderCollapsedShadow={showHeaderCollapsedShadow}
            scrollTop={scrollTop}
            goBack={goBack}
            containerStyle={containerStyle}
            showBackForSingleCatalogue={showBackForSingleCatalogue}
          />
        ) : null}
      </header>
    );
  }
}

export default Header;
